import superPlanVideo from '@assets/video/super-plan-intro.mp4'
import { superBrandGradient } from '@/customTheme'
import type { PlanType } from './MetsiKonChoosePlan'
import { AI_MODELS_HD_SOURCE } from '@/scenes/engine/utils/aiModelsAnalytics'
import { BATCH_AI_TOOLS_SUPER_SOURCES } from '@/scenes/BatchStudio/analytics/batchAIToolsAnalytics'

export type { PlanType }

export const PREMIUM_FEATURES = [
  'Unlock advanced AI tools',
  '250 AI credits monthly',
  'Batch edit up to 500 photos at once',
  'Create on-model and studio product shots',
  'Remove people and objects',
  'Access all content and editing tools',
  'Save without watermark',
]

export const SUPER_FEATURES = [
  'Everything in Premium',
  'Unlock AI video',
  'Best AI models (nano banana, GPT image)',
  '4x more AI credits',
  'Generate on-model & product shots in HD',
  'VIP support',
]

interface PlanVariantTokens {
  checkColor: string
  choosePlanGradient: string
  introButtonGradient: string | null
  introVideo: string | null
  features: readonly string[]
}

const PLAN_VARIANTS: Record<PlanType, PlanVariantTokens> = {
  premium: {
    checkColor: '#FF0560',
    choosePlanGradient:
      'linear-gradient(0deg, rgba(251, 248, 255, 0.10) 0%, rgba(255, 5, 96, 0.15) 100%)',
    introButtonGradient: null,
    introVideo: null,
    features: PREMIUM_FEATURES,
  },
  super: {
    checkColor: '#9d01f4',
    choosePlanGradient:
      'linear-gradient(0deg, rgba(251, 248, 255, 0.10) 0%, rgba(157, 1, 244, 0.15) 100%)',
    introButtonGradient: superBrandGradient,
    introVideo: superPlanVideo,
    features: SUPER_FEATURES,
  },
}

export function getPlanVariant(planType: PlanType): PlanVariantTokens {
  return PLAN_VARIANTS[planType]
}

const SUPER_INITIAL_SOURCES = new Set<string>([
  'Header_CTA_Super',
  'BtSubscriptionOutOfCredits',
  'BtSubscriptionAIHD',
  AI_MODELS_HD_SOURCE,
  'BtSubscriptionAIVideo',
  ...BATCH_AI_TOOLS_SUPER_SOURCES,
])

export function resolveInitialPlanType(source: string | null | undefined): PlanType {
  if (source && SUPER_INITIAL_SOURCES.has(source)) return 'super'
  return 'premium'
}

export function getIntroTitleKey(planType: PlanType): string {
  return planType === 'super' ? 'Upgrade to Super' : 'Try Bazaart Premium'
}

export function getIntroSubtitleKey(planType: PlanType): string {
  return planType === 'super'
    ? 'Best for growing online sellers and brands.'
    : 'Give yourself extra design superpowers!'
}

export function getIntroCtaKey(
  planType: PlanType,
  userHadFreeTrial: boolean | undefined,
): string {
  if (planType === 'super') return 'Upgrade to Super'
  return userHadFreeTrial ? 'Try it now' : 'Try it free'
}
